import { FeatureFlag } from '../FeatureFlag';

export const useRustAssistant = new FeatureFlag({
    key: 'use-rust-assistant',
    createdOn: '2026-10-16',
    defaultValue: false,
});
